<div>
	@if (tRows.length > 0 || tRows.length === 0 && isFiltersApplied) {
	<div class="table-management">
		<div class="left">
			<span class="total">{{ 'gl.total' | translate }}: {{ total }}</span>
			<button (click)="editTableFilter()" alaris-button bType="outline" size="lg">
				<alaris-icon name="icon-filter-vertical"></alaris-icon>
				{{ 'gl.filter.filters' | translate }}
				@if (isFiltersApplied) {
				<div class="indicator"></div>
				}
			</button>
		</div>
		<div class="right">
			<button (click)="load()" alaris-button bType="outline" size="lg">
				<alaris-icon name="icon-refresh-clock-wise"></alaris-icon>
				{{ 'actions.refresh_page' | translate }}
			</button>
			<button alarisButton [bType]="'primary'" size="lg" [ripple]="true" (click)="confirm()">
				{{ 'gl.export_results' | translate }}
				<alaris-icon name="icon-arrow-line-down"></alaris-icon>
			</button>
		</div>
	</div>
	}

	<alaris-table
		(filtersChange)="applyFilter($event)"
		[filters]="filters()"
		[fixFirstColumn]="false"
		[resizable]="false"
		[tHeaders]="tHeaders()"
		[tRows]="tRows"
		[templates]="{contextLog, number}"
		class="alaris-table"
		[alarisLoading]="service.loading$"></alaris-table>

	<div class="footer">
		<alaris-pagination
			(page)="paginationChange($event)"
			[activePage]="activePage"
			[hidden]="total === 0"
			[pageSizeOptions]="pageSizeOptions"
			[pageSize]="pageSize"
			[total]="total"></alaris-pagination>
	</div>
</div>

<ng-template #contextLog let-data="data" let-key="key">
	<alaris-link (click)="viewLog(data.contextLog)" data-testid="viewLogLink">
		{{ 'actions.view' | translate }}
	</alaris-link>
</ng-template>

<ng-template #number [alarisCellCtx]="tRows[0]" let-data="data" let-key="key">
	<div class="number">
		<alaris-icon name="icon-warning-_active"></alaris-icon>
		<div>{{ data.number | phoneNumber }}</div>
	</div>
</ng-template>
